
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1 31.61h38v6.55H1zM37.69 31a17.69 17.69 0 00-35.38 0M31.42 27.38A11.88 11.88 0 0020 18.75M20 9.99v3.28M20 3.838l3.536 3.536-3.535 3.535-3.536-3.535z"}})])
          )
        }
      }
    